import { FunctionComponent } from 'react';
import ModalForm, { HandleSave } from '../../components/ModalForm';
import { Plus, Pencil } from 'react-bootstrap-icons';

interface FormInput {
  id: string;
  name: string;
}

const UpsertFacilityButton: FunctionComponent<{
  handleSave: HandleSave<FormInput>;
  editFields?: FormInput;
}> = (props) =>
  ModalForm<FormInput>({
    buttonLabel: <Plus />,
    editButtonLabel: <Pencil />,
    inputs: {
      id: {
        type: 'text',
        label: 'ID',
        editable: false,
        settable: false,
      },
      name: {
        type: 'text',
        label: 'Name',
        validationOptions: { required: true },
        editable: true,
      },
    },
    ...props,
    buttonSize: 'sm',
  });

export default UpsertFacilityButton;
